import type { PrefetchContext, PrefetchedDataProps } from 'src/shared/prefetch';

import { useLocale } from 'src/app/shared/hooks/l10n';

import { prefetchImpactStoryPageDataFromApi, useImpactStoryPageDataFromApi } from './pageData';

export type ImpactStoryPagePrefetchedContext = Readonly<{
	pageData: NonNullable<Parameters<typeof useImpactStoryPageDataFromApi>[0]>;
}>;

export type ImpactStoryPageCombinedState = ReturnType<typeof useImpactStoryPageDataFromApi>;

export function usePageContext(
	slug: string,
	prefetchedData?: ImpactStoryPagePrefetchedContext,
): ImpactStoryPageCombinedState {
	const locale = useLocale();
	return useImpactStoryPageDataFromApi(prefetchedData?.pageData, slug, locale);
}

export async function prefetchPageContext(
	slug: string,
	context: PrefetchContext,
): Promise<ImpactStoryPagePrefetchedContext> {
	const pageData = await prefetchImpactStoryPageDataFromApi(context, slug, context.l10n.locale);

	return { pageData };
}

export type ImpactStoryPagePrefetchedDataProps = PrefetchedDataProps<ImpactStoryPagePrefetchedContext>;
